import { render, staticRenderFns } from "./CourseForm.vue?vue&type=template&id=b2eed454&scoped=true"
import script from "./CourseForm.vue?vue&type=script&lang=js"
export * from "./CourseForm.vue?vue&type=script&lang=js"
import style0 from "./CourseForm.vue?vue&type=style&index=0&id=b2eed454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2eed454",
  null
  
)

export default component.exports